// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-row .cpj-nav-list .opacity-white:hover{color:#0ea5bf!important}.footer-row .cpj-nav-list .opacity-white:visited{color:#788796}", ""]);
// Exports
module.exports = exports;
